"use strict";
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderLineItem = exports.PaymentStatus = exports.PaymentMethod = exports.ShippingMethod = exports.LineItemStatus = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const order_entity_1 = require("./order.entity");
const product_entity_1 = require("../products/product.entity");
const shipment_line_item_entity_1 = require("./shipment-line-item.entity");
var LineItemStatus;
(function (LineItemStatus) {
    LineItemStatus["WROTE_SLIP"] = "wrote_slip";
    LineItemStatus["PACKED"] = "packed";
    LineItemStatus["DISPATCHED"] = "dispatched";
    LineItemStatus["IN_TRANSIT"] = "in_transit";
    LineItemStatus["DELIVERED"] = "delivered";
    LineItemStatus["ON_HOLD"] = "on_hold";
    LineItemStatus["RTO"] = "rto";
    LineItemStatus["RETURNED"] = "returned_by_patient";
})(LineItemStatus || (exports.LineItemStatus = LineItemStatus = {}));
var ShippingMethod;
(function (ShippingMethod) {
    ShippingMethod["FLIGHT"] = "flight";
    ShippingMethod["RAPIDO"] = "rapido";
    ShippingMethod["BY_BUS"] = "by_bus";
    ShippingMethod["STANDARD_COURIER"] = "standard_courier";
    ShippingMethod["PICKUP"] = "pickup";
})(ShippingMethod || (exports.ShippingMethod = ShippingMethod = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["UPI"] = "upi";
    PaymentMethod["BANK_TRANSFER"] = "bank_transfer";
    PaymentMethod["COD"] = "cod";
    PaymentMethod["CARD"] = "card";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "pending";
    PaymentStatus["SHARED"] = "shared";
    PaymentStatus["VERIFIED"] = "verified";
    PaymentStatus["FAILED"] = "failed";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
let OrderLineItem = class OrderLineItem {
};
exports.OrderLineItem = OrderLineItem;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OrderLineItem.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => order_entity_1.Order, (o) => o.lineItems, { onDelete: 'CASCADE', nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: 'orderId' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof order_entity_1.Order !== "undefined" && order_entity_1.Order) === "function" ? _a : Object)
], OrderLineItem.prototype, "order", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'orderId' }),
    tslib_1.__metadata("design:type", Number)
], OrderLineItem.prototype, "orderId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => product_entity_1.Product, (p) => p.lineItems, { eager: true, nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: 'productId' }),
    tslib_1.__metadata("design:type", typeof (_b = typeof product_entity_1.Product !== "undefined" && product_entity_1.Product) === "function" ? _b : Object)
], OrderLineItem.prototype, "product", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'productId' }),
    tslib_1.__metadata("design:type", Number)
], OrderLineItem.prototype, "productId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)(),
    tslib_1.__metadata("design:type", Number)
], OrderLineItem.prototype, "quantity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'decimal', precision: 10, scale: 2 }),
    tslib_1.__metadata("design:type", Number)
], OrderLineItem.prototype, "unitPrice", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'decimal', precision: 10, scale: 2 }),
    tslib_1.__metadata("design:type", Number)
], OrderLineItem.prototype, "lineTotal", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 80, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OrderLineItem.prototype, "stockLocation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OrderLineItem.prototype, "deliveryAddressId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], OrderLineItem.prototype, "isSplit", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], OrderLineItem.prototype, "splitGroupId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: ShippingMethod, default: ShippingMethod.STANDARD_COURIER }),
    tslib_1.__metadata("design:type", String)
], OrderLineItem.prototype, "shippingMethod", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'decimal', precision: 10, scale: 2, default: 0 }),
    tslib_1.__metadata("design:type", Number)
], OrderLineItem.prototype, "shippingCharge", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: PaymentMethod, default: PaymentMethod.UPI }),
    tslib_1.__metadata("design:type", String)
], OrderLineItem.prototype, "paymentMethod", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: PaymentStatus, default: PaymentStatus.PENDING }),
    tslib_1.__metadata("design:type", String)
], OrderLineItem.prototype, "paymentStatus", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: LineItemStatus, default: LineItemStatus.WROTE_SLIP }),
    tslib_1.__metadata("design:type", String)
], OrderLineItem.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 100, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OrderLineItem.prototype, "trackingId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 80, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OrderLineItem.prototype, "carrier", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OrderLineItem.prototype, "dispatchDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], OrderLineItem.prototype, "deliveredAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'json', nullable: true }),
    tslib_1.__metadata("design:type", Array)
], OrderLineItem.prototype, "mediaUrls", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], OrderLineItem.prototype, "statusReason", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], OrderLineItem.prototype, "issueReportDeadline", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => shipment_line_item_entity_1.ShipmentLineItem, (shipmentLineItem) => shipmentLineItem.lineItem),
    tslib_1.__metadata("design:type", Array)
], OrderLineItem.prototype, "shipmentItems", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], OrderLineItem.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], OrderLineItem.prototype, "updatedAt", void 0);
exports.OrderLineItem = OrderLineItem = tslib_1.__decorate([
    (0, typeorm_1.Entity)('order_line_items')
], OrderLineItem);
